import { getSubscriptionApiClient } from "@shared/apis/sidekick/api-factories";
import { GetOfferDescriptionResponse } from "@shared/apis/sidekick/generated";
import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";

type Props = {
  onSuccess?: (data: GetOfferDescriptionResponse) => void;
};

const buildAdminGetSubscriptionOffersQueryKey = () => {
  return ["admin-subscription-offers"];
};

const CACHE_TIME_IN_MS = 1000 * 60 * 10; // 10 minutes

export const useAdminGetSubscriptionOffers = (params?: Props) => {
  const { onSuccess } = params || {};

  const api = getSubscriptionApiClient();
  const query = useQuery({
    queryKey: buildAdminGetSubscriptionOffersQueryKey(),
    queryFn: async () => {
      try {
        const data = await api.subscriptionControllerDescribeAllOffers();
        onSuccess?.(data);
        return data;
      } catch (error) {
        console.error(`Failed to get subscription plans`, error);
        throw error;
      }
    },
    enabled: true,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    gcTime: CACHE_TIME_IN_MS,
    staleTime: CACHE_TIME_IN_MS,
  });

  return extractQueryState(query);
};
